import useGetApi from 'src/api/useGetApi';

export interface User {
  id: string;
  name: string;
  email: string | null;
  avatar?: string | null;
}

interface SearchUsersResponse {
  users: User[];
}

interface QueryParams {
  query: string;
  limit?: number;
}

const useSearchUsers = (params: QueryParams, enabled?: boolean) => {
  return useGetApi<SearchUsersResponse>({
    endpoint: 'core/users/search',
    queryParameters: params,
    options: {
      enabled,
    },
  });
};

export default useSearchUsers;
